import { ApiError } from '@/services/ApiError';

import { StatusState } from './StatusState';

/** Maps any data-layer error to the right screen, with Retry. */
export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const offline = error instanceof ApiError && error.kind === 'network';
  const retry = onRetry ? { label: 'Try again', onClick: onRetry } : undefined;
  return (
    <StatusState
      tone={offline ? 'offline' : 'error'}
      title={offline ? 'You are offline' : 'Something went wrong'}
      description={
        error instanceof ApiError
          ? error.message
          : 'We could not load this right now. Please try again.'
      }
      {...(retry ? { action: retry } : {})}
    />
  );
}
